export const heroStats = [
  { value: '+500', label: 'terapeutas equipados' },
  { value: '5', label: 'volúmenes principales' },
  { value: '3', label: 'bonus incluidos' },
  { value: '4.9/5', label: 'valoración' },
]

export const recentPurchases = [
  { name: 'Valentina R.', city: 'Guadalajara', ago: 'hace 2 minutos' },
  { name: 'Camila S.', city: 'Bogotá', ago: 'hace 5 minutos' },
  { name: 'Diego M.', city: 'Lima', ago: 'hace 8 minutos' },
]

export const costRows = [
  { without: 'Indicar sin ficha técnica validada', cost: 'Inseguridad clínica que el paciente percibe' },
  { without: 'Sin semáforo de seguridad por planta', cost: 'Riesgo real de indicar algo contraindicado' },
  { without: 'Sin tabla de interacciones', cost: 'Paciente medicado en riesgo sin saberlo' },
  { without: 'Sin protocolo por sistema', cost: 'Cada sesión construida desde cero, sin estructura' },
  { without: 'Sin recetario de fórmulas', cost: 'Combinaciones improvisadas sin respaldo' },
  { without: 'Sin dosificación pediátrica', cost: 'No sabes cómo ajustar para niños o adultos mayores' },
  { without: 'Sin criterios de derivación', cost: 'No sabes cuándo la fitoterapia no es suficiente' },
  { without: 'Sin ficha de consultorio', cost: 'Cada consulta sin registro ni continuidad real' },
  { without: 'Sin guía de proveedores', cost: 'Materia prima de calidad desconocida' },
  { without: 'Sin espagiria vegetal', cost: 'Pierdes pacientes que buscan preparaciones avanzadas' },
  { without: 'Sin el sistema', cost: 'El mismo ciclo de incertidumbre, la próxima semana' },
]

export const pillars = [
  {
    emoji: '🌱',
    title: 'Fichas de plantas',
    text: 'Información organizada sobre usos, preparaciones y precauciones.',
  },
  {
    emoji: '⚗️',
    title: 'Métodos de elaboración',
    text: 'Pasos y recursos para estudiar y preparar tu trabajo.',
  },
  {
    emoji: '📋',
    title: 'Planillas de seguimiento',
    text: 'Herramientas para registrar cada encuentro y retomar la información.',
  },
]

export const libraryChecks = [
  'Consulta fichas de plantas.',
  'Revisa métodos de preparación.',
  'Encuentra material sobre precauciones e interacciones.',
  'Consulta el recetario.',
  'Registra cada encuentro con las planillas.',
]

export const volumes = [
  {
    emoji: '🌱',
    label: 'Volumen I',
    title: 'Enciclopedia Global de Fitoterapia',
    description:
      'Fichas visuales con nombre científico, principios activos, usos, formas de preparación, precauciones e interacciones.',
    takeaway: 'Información de cada planta organizada para consultar.',
    cover:
      'https://cdn.magicpatterns.com/uploads/ucVFEz4RpswFeLMug97ES1/Screenshot_20260812-195520~2.jpg',
  },
  {
    emoji: '🌿',
    label: 'Volumen II',
    title: 'Enciclopedia Global de Fitoterapia',
    description:
      'Continúa la colección con más fichas de plantas y el mismo enfoque visual de consulta.',
    takeaway:
      'Una ampliación de tu biblioteca para recorrer y estudiar distintas especies.',
    cover:
      'https://cdn.magicpatterns.com/uploads/g1mqfeRygwzNnMb7AXF3M8/Screenshot_20260812-195619~2.jpg',
  },
  {
    emoji: '⚗️',
    label: 'Volumen III',
    title: 'Tratado de Preparaciones y Galénica Natural',
    description:
      'Métodos de elaboración de infusiones, decocciones, tinturas, oleatos, pomadas y otras preparaciones. Incluye material sobre conservación, envasado y control de calidad.',
    takeaway: 'Consulta los pasos de elaboración y organiza tus preparaciones.',
    cover:
      'https://cdn.magicpatterns.com/uploads/3crcVu1FV4QrmEcDptY6s8/Screenshot_20260812-195657~2.jpg',
  },
  {
    emoji: '📋',
    label: 'Volumen IV',
    title: 'Clínica e Interacciones Medicamentosas',
    description:
      'Material sobre protocolos por sistemas del cuerpo, interacciones planta–fármaco, precauciones para distintas poblaciones y criterios de derivación médica.',
    takeaway:
      'Un apoyo de consulta dentro de tu formación y alcance profesional.',
    cover:
      'https://cdn.magicpatterns.com/uploads/dES5Prtoctm3WWoE3aDoVi/Screenshot_20260812-195739~2.jpg',
  },
  {
    emoji: '✨',
    label: 'Volumen V',
    title: 'Alquimia Vegetal y Espagiria Moderna',
    description:
      'Fundamentos de espagiria, procesos de elaboración y propuestas de fitococina.',
    takeaway:
      'Contenido avanzado para profundizar en esta tradición de las preparaciones vegetales.',
    cover:
      'https://cdn.magicpatterns.com/uploads/aFBx9cK3C5mzfBmDs83xuK/Screenshot_20260812-195822~2.jpg',
  },
]

export const bonuses = [
  {
    emoji: '📋',
    label: 'Bonus 1',
    title: 'Fichas de Consultorio',
    text: 'Organiza los datos de cada paciente y registra su seguimiento.',
  },
  {
    emoji: '🌿',
    label: 'Bonus 2',
    title: 'Recetario Maestro',
    text: 'Consulta fórmulas, preparaciones y precauciones en un solo lugar.',
  },
  {
    emoji: '🧺',
    label: 'Bonus 3',
    title: 'Guía de Proveedores y Cosecha Ética',
    text: 'Aprende qué revisar al seleccionar y conservar tus plantas.',
  },
]

export const testimonials = [
  {
    initials: 'VP',
    name: 'Valentina P.',
    location: 'Montevideo, Uruguay',
    text: 'Las Fichas de Consultorio transformaron mi consultorio. Ahora cada paciente tiene un registro completo desde el primer día. Profesionalicé mi práctica en una semana.',
  },
  {
    initials: 'RG',
    name: 'Roberto G.',
    location: 'Guadalajara, México',
    text: 'Lo que más me sorprendió fue la profundidad del Recetario Maestro. Fórmulas listas para usar, con precauciones claras. Ya no improviso en consulta.',
  },
  {
    initials: 'DL',
    name: 'Diego L.',
    location: 'Santiago, Chile',
    text: 'El Volumen V de Alquimia Vegetal me abrió un camino que no imaginaba. La espagiria combinada con la fitococina terapéutica es un diferencial absoluto en mi práctica.',
  },
]

export const includedItems = [
  'Dos volúmenes enciclopédicos de plantas medicinales.',
  'Tratado de Preparaciones y Galénica Natural.',
  'Clínica e Interacciones Medicamentosas.',
  'Alquimia Vegetal y Espagiria Moderna.',
  'Fichas de Consultorio.',
  'Recetario Maestro.',
  'Guía de Proveedores y Cosecha Ética.',
]

export const faqs = [
  {
    q: '¿Para quién es este megapack?',
    a: 'Para terapeutas y personas con formación en plantas medicinales que buscan recursos organizados de consulta, preparación y seguimiento.',
  },
  {
    q: '¿Qué incluye?',
    a: 'Cinco volúmenes principales y tres bonus: ocho archivos PDF con 405 páginas en total, incluyendo portadas y páginas introductorias.',
  },
  {
    q: '¿Son libros físicos?',
    a: 'Son ebooks en PDF. Puedes consultarlos en celular, tablet o computadora e imprimir las páginas que necesites.',
  },
  {
    q: '¿Necesito imprimir todo?',
    a: 'Puedes usarlo en pantalla y seleccionar únicamente las páginas que quieras imprimir.',
  },
  {
    q: '¿Es un curso o incluye certificación?',
    a: 'Es una biblioteca de consulta. No incluye clases ni certificación profesional.',
  },
  {
    q: '¿Reemplaza mi formación o el criterio profesional?',
    a: 'El material complementa tu estudio y organización. Su uso debe ajustarse a tu formación y alcance profesional; no sustituye el diagnóstico ni el tratamiento médico.',
  },
  {
    q: '¿Las plantas se consiguen en mi país?',
    a: 'La disponibilidad varía según la especie y tu ubicación. La guía de abastecimiento incluye criterios para evaluar proveedores y materia prima.',
  },
  {
    q: '¿Qué diferencia tiene frente a buscar información suelta?',
    a: 'Reúne fichas, preparaciones, material de consulta y planillas en una misma colección, para que puedas recorrer sus recursos sin reunirlos desde cero.',
  },
  {
    q: '¿En qué moneda pago?',
    a: 'El precio es US$15. Si pagas con una tarjeta en otra moneda, la conversión y posibles cargos dependen de tu banco o medio de pago.',
  },
  {
    q: '¿Tiene garantía?',
    a: 'Sí. Puedes solicitar la devolución dentro de los siete días posteriores a tu compra.',
  },
  {
    q: '¿Puedo compartir los archivos?',
    a: 'La compra es para uso personal. No está autorizada su redistribución ni reventa.',
  },
  {
    q: '¿Cómo resuelvo una duda?',
    a: 'Escríbenos a soportelumenakasha@gmail.com o a @lumen.akasha.',
  },
]
